






































import {Component, Vue, Watch} from "vue-property-decorator";
import BaseOverview, {Loadable} from "@/resources/components/BaseOverview.vue";
import Project from '@/app/models/Project';
import Debounce from "@/app/support/Debounce";
import ProgressMixin, { ProgressConfig } from "@/app/mixins/SampleMixin";
import ProgressBar from "@/resources/components/ProgressBar.vue";
import Station from "@/app/models/Station";

@Component({
    components: {BaseOverview, ProgressBar},
    mixins: [ProgressMixin]
})
export default class Brands extends Vue {
    project: Project = new Project({});
    search: string = '';
    $refs!: { overview: BaseOverview }

    getProgress!: (total_brands: number) => ProgressConfig;

    get station(): Station|null {
        return this.$store.state.data.station;
    }

    @Watch('search')
    @Debounce(250)
    onSearchUpdated() {
        this.$refs.overview.reset();
    }

    async mounted() {
        this.project = await Project.show(parseInt(this.$route.params.projectId)) as Project;
    }

    async loadItems(loadable: Loadable) {
        loadable.loadItems(
            (await Project.brands(loadable.page, {
                project_id: this.$route.params.projectId,
                checklists: true,
                search: this.search,
            })).data
        );
    }
}
